import React from 'react';
import { QykfinLogoSimple } from './QykfinLogo';
import { useLanguage } from '../context/LanguageContext';
import { Heart } from 'lucide-react';

const Footer = () => {
  const { t, isRTL } = useLanguage();

  return (
    <footer className="bg-[#FAFAFA] border-t border-[#E5E5E5]/60">
      <div className="max-w-[1200px] mx-auto px-6 py-12 md:py-16">
        <div className={`grid md:grid-cols-4 gap-10 mb-12 ${isRTL ? 'direction-rtl' : ''}`}>
          {/* Brand */}
          <div className={`md:col-span-1 ${isRTL ? 'text-right' : ''}`}>
            <QykfinLogoSimple />
            <p className="text-[#6e6e73] font-inter text-[14px] mt-4 leading-relaxed">
              {t.footer.tagline}
            </p>
          </div>

          {/* Product Links */}
          <div className={isRTL ? 'text-right' : ''}>
            <h4 className="font-dm font-semibold text-[#1D1D1F] mb-4">{t.footer.links.product}</h4>
            <ul className="space-y-3">
              <li>
                <a href="#features" className="text-[#6e6e73] hover:text-[#0071E3] font-inter text-[14px] transition-colors">
                  {t.footer.links.features}
                </a>
              </li>
              <li>
                <a href="/uae-loan-calculator" className="text-[#6e6e73] hover:text-[#0071E3] font-inter text-[14px] transition-colors">
                  {t.footer.links.calculator}
                </a>
              </li>
              <li>
                <a href="/blog" className="text-[#6e6e73] hover:text-[#0071E3] font-inter text-[14px] transition-colors">
                  {t.footer.links.blog}
                </a>
              </li>
            </ul>
          </div>

          {/* Company Links */}
          <div className={isRTL ? 'text-right' : ''}>
            <h4 className="font-dm font-semibold text-[#1D1D1F] mb-4">{t.footer.links.company}</h4>
            <ul className="space-y-3">
              <li>
                <a href="/about-us" className="text-[#6e6e73] hover:text-[#0071E3] font-inter text-[14px] transition-colors">
                  {t.footer.links.about}
                </a>
              </li>
              <li>
                <a href="#" className="text-[#6e6e73] hover:text-[#0071E3] font-inter text-[14px] transition-colors">
                  {t.footer.links.careers}
                </a>
              </li>
              <li>
                <a href="#" className="text-[#6e6e73] hover:text-[#0071E3] font-inter text-[14px] transition-colors">
                  {t.footer.links.contact}
                </a>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div className={isRTL ? 'text-right' : ''}>
            <h4 className="font-dm font-semibold text-[#1D1D1F] mb-4">{t.footer.links.legal}</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-[#6e6e73] hover:text-[#0071E3] font-inter text-[14px] transition-colors">
                  {t.footer.links.privacy}
                </a>
              </li>
              <li>
                <a href="#" className="text-[#6e6e73] hover:text-[#0071E3] font-inter text-[14px] transition-colors">
                  {t.footer.links.terms}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className={`pt-8 border-t border-[#E5E5E5]/60 flex flex-col md:flex-row items-center justify-between gap-4 ${isRTL ? 'md:flex-row-reverse' : ''}`}>
          <p className="text-[#86868b] font-inter text-[13px]">
            {t.footer.copyright}
          </p>
          <div className={`flex items-center gap-1.5 text-[#86868b] text-[13px] font-inter ${isRTL ? 'flex-row-reverse' : ''}`}>
            <span>{t.footer.madeIn}</span>
            <Heart className="w-3.5 h-3.5 text-[#FF3B30] fill-[#FF3B30]" />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
